import React, {Component} from 'react';
import {formatDate, formatTime} from '../dashboard/functions/utils';
import $ from 'jquery';
import {NavLink} from 'react-router-dom';
import Alert from 'react-s-alert';
import ReactTooltip from "react-tooltip";
import {withTranslation} from "react-i18next";
import {withCookies} from 'react-cookie';
import {Redirect} from "react-router";
import Moment from 'moment-timezone';
import {Modal} from 'react-responsive-modal';

import LoggingBox from '../dashboard/popoutComponents/loggingBox';
import packageJson from "../../package.json";
import Collapsible from "react-collapsible";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

const telemetryIP = process.env.REACT_APP_TELEMETRY_IP;
const telemetryPort = process.env.REACT_APP_MESSAGE_PORT;

const super_admin = parseInt(process.env.REACT_APP_SUPER_ADMIN_ID);
const admin = parseInt(process.env.REACT_APP_EVENT_ADMIN_ID);
const sub_admin = parseInt(process.env.REACT_APP_EVENT_SUB_ADMIN_ID);

const MiniPitStopSessionTypeID = 7;

class SessionChoice extends Component {

    constructor(props) {
        super(props);

        this.state = {
            eventGroupListUpcoming: [],
            eventGroupListStarted: [],
            eventGroupListEnded: [],
            platformSwitch: false,
            logout: false,
            flagList: [{id: -1, desc: "---", src: "none_transparent.png"}],
            sessionDetails: null,
            marshallPosts: [],
        };

        this.getEvents = this.getEvents.bind(this);
        this.startSessionCommand = this.startSessionCommand.bind(this);
        this.handleSwitchPlatform = this.handleSwitchPlatform.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.getFlagList = this.getFlagList.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        if (this.props.cookies.get("authToken") && this.props.location.state) {
            this.getEvents();
            this.getFlagList();
        }
    }

    /* GET DATA */
    getEvents() {
        $('.loading').fadeIn();
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getEventList',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                userID: helper.props.location.state.userID,
                privileges: JSON.stringify(helper.props.location.state.privileges),
            },
            success: function (data) {
                helper.setState({
                    eventGroupListUpcoming: data.upcoming,
                    eventGroupListStarted: data.started,
                    eventGroupListEnded: data.ended,
                }, () => {
                    $('.loading').fadeOut();
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                return false;
            }
        });
    }

    getFlagList() {
        const helper = this;
        $.ajax({
            type: 'GET',
            url: serverIP + ":" + backendPort + '/dashboard/getFlagList',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            success: function (data) {
                helper.setState({
                    flagList: data.collective.concat(data.singular).concat(data.fullCourse),
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                helper.setState({
                    flagList: [
                        {id: -1, desc: "---", src: "none_transparent.png"}
                    ],
                });
            }
        });
    }

    /* HANDLERS */
    handleSwitchPlatform(e) {
        this.setState({
            platformSwitch: true,
        });
    }

    handleLogout(e) {
        this.setState({
            logout: true,
        });
    }

    startSessionCommand(eventID, sessionID) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: telemetryIP + ':' + telemetryPort + '/command-worker-device?command=RT-ORG-SESSION-START&eventId=' + eventID + '&sessionId=' + sessionID + '&userId=' + helper.props.location.state.userID,
            headers: {
                'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
            },
            dataType: 'json',
            success: function () {
                console.log('[SESSION CHOICE] Successfully sent session reset request.');
                helper.getEvents();
            }, error: function (err) {
                if (err) {
                    console.error('[SESSION CHOICE] Error sending session reset request.');
                }
                Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("actionError") + '</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }
        });
    }

    /* RENDER */
    render() {
        return (
            (this.state.logout || this.state.platformSwitch || !this.props.cookies.get("authToken") || !this.props.location.state) ? (
                <Redirect to={{pathname: "/external-redirect/" + (this.state.logout ? "logout" : "platform")}}/>
            ) : (
                <>
                    <div className={"App_big_white_text"} style={{position: "fixed", top: 0, left: 0, margin: 25, zIndex: -1}}>
                        v{packageJson.version}
                    </div>
                    <Alert stack={{limit: 10}} html={true}/>
                    <div id={"scroller-right"}>
                        <button
                            data-tip={true}
                            data-for={"platform"}
                            onClick={this.handleSwitchPlatform}
                            className={"btn App_white_text button"}
                            style={{background: "#ed2126", color: "#FFFFFF"}}
                        >
                            <i className={"fas fa-external-link-alt"}/>
                        </button>
                        <br/>
                        <br/>
                        <button
                            data-tip={true}
                            data-for={"logout"}
                            onClick={this.handleLogout}
                            className={"btn App_white_text button"}
                            style={{background: "#ed2126", color: "#FFFFFF"}}
                        >
                            <i className={"fas fa-power-off"}/>
                        </button>

                        <ReactTooltip id={"platform"} type={"light"} place={"left"}>
                            <span className={"toolTipStyle"}>{this.props.t("switchPlatform")}</span>
                        </ReactTooltip>
                        <ReactTooltip id={"logout"} type={"light"} place={"left"}>
                            <span className={"toolTipStyle"}>{this.props.t("logout")}</span>
                        </ReactTooltip>

                    </div>
                    <div className={"container-fluid col-xs-10 col-lg-8 col-xs-offset-1 col-lg-offset-2"}>
                        <div className={"loading"}>
                            <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                        </div>
                        <div className={"row w3-animate-fading"}>
                            <div className={"App_modernContainer col-md-12"}>
                                <div className={"col-md-12"}>
                                    <h2 className={"App_sessionTitle"}>{this.props.t('onGoingSessions')}</h2>
                                    <hr/>
                                </div>
                                {Object.keys(this.state.eventGroupListStarted).length > 0 ? (
                                    Object.keys(this.state.eventGroupListStarted).map((year) => {
                                        return (
                                            <div key={"started_year_" + year}>
                                                <div className={"col-md-12"} style={{padding: 0}}>
                                                    <span className={"App_year"}>{year}</span>
                                                    <hr style={{marginTop: 0}}/>
                                                </div>
                                                {this.state.eventGroupListStarted[year].map((eventGroup) => {
                                                    return (
                                                        <Collapsible
                                                            key={"event_group_" + eventGroup[0][0].event_group_id}
                                                            open={true}
                                                            trigger={
                                                                <div className={"row"}>
                                                                    <div className={"col-md-12"} style={{backgroundImage: "linear-gradient(to right, #F7F7F7 0, #eb1f247d 100%)", margin: "0 8px 5px 8px", borderRadius: 5, cursor: "pointer"}}>
                                                                        <span className={"text-center App_title"} style={{fontStyle: "italic", fontSize: 25}}>
                                                                            {eventGroup[0][0].event_group_name}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            }
                                                        >
                                                            <div className={"row row-flex"}>
                                                                {eventGroup.map((event, i) => {
                                                                    return (
                                                                        <div className={"col-xs-12 collapseMargin"} key={event[0].event_name + "_" + i}>
                                                                            <div className={"col-md-12"}>
                                                                                <h4 className={"App_eventName"}>{event[0].event_name}</h4>
                                                                            </div>
                                                                            <div className={"col-xs-12 collapseMargin"}>
                                                                                {event.map((session) => {
                                                                                    return (
                                                                                        <SessionOnGoingCard
                                                                                            key={session.session_id}
                                                                                            event={session}
                                                                                            userID={this.props.location.state.userID}
                                                                                            privileges={this.props.location.state.privileges}
                                                                                            t={this.props.t}
                                                                                            cookies={this.props.cookies}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </Collapsible>
                                                    );
                                                })}
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div>
                                        <span className={"App_bold_text"} style={{fontSize: 22}}>{this.props.t("noOpenSessions")}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <hr/>
                        <div className={"row w3-animate-fading"}>
                            <div className={"App_modernContainer col-md-12"}>
                                <div className={"col-md-12"}>
                                    <h2 className={"App_sessionTitle"}>{this.props.t("upcomingSessions")}</h2>
                                    <hr/>
                                </div>
                                {Object.keys(this.state.eventGroupListUpcoming).length > 0 ? (
                                    Object.keys(this.state.eventGroupListUpcoming).map((year) => {
                                        return (
                                            <div key={"upcoming_year_" + year}>
                                                <div className={"col-md-12"} style={{padding: 0}}>
                                                    <span className={"App_year"}>{year}</span>
                                                    <hr style={{marginTop: 0}}/>
                                                </div>
                                                {this.state.eventGroupListUpcoming[year].map((eventGroup) => {
                                                    return (
                                                        <Collapsible
                                                            key={"event_group_" + eventGroup[0][0].event_group_id}
                                                            open={true}
                                                            trigger={
                                                                <div className={"row"}>
                                                                    <div className={"col-md-12"} style={{backgroundImage: "linear-gradient(to right, #F7F7F7 0, #eb1f247d 100%)", margin: "0 8px 5px 8px", borderRadius: 5, cursor: "pointer"}}>
                                                                        <span className={"text-center App_title"} style={{fontStyle: "italic", fontSize: 25}}>
                                                                            {eventGroup[0][0].event_group_name}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            }
                                                        >
                                                            <div className={"row row-flex"}>
                                                                {eventGroup.map((event, i) => {
                                                                    return (
                                                                        <div className={"col-xs-12 collapseMargin"} key={event[0].event_name + "_" + i}>
                                                                            <div className={"col-md-12"}>
                                                                                <h4 className={"App_eventName"}>{event[0].event_name}</h4>
                                                                            </div>
                                                                            <div className={"col-xs-12 collapseMargin"}>
                                                                                {event.map((session) => {
                                                                                    return (
                                                                                        <SessionUpcomingCard
                                                                                            key={session.session_id}
                                                                                            event={session}
                                                                                            userID={this.props.location.state.userID}
                                                                                            startSessionCommand={this.startSessionCommand}
                                                                                            privileges={this.props.location.state.privileges}
                                                                                            t={this.props.t}
                                                                                            cookies={this.props.cookies}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </Collapsible>
                                                    );
                                                })}
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div>
                                        <span className={"App_bold_text"} style={{fontSize: 22}}>{this.props.t('noUpcomingSessions')}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={"row w3-animate-fading"}>
                            <div className={"App_modernContainer col-md-12 clearfix"}>
                                <div className={"col-md-12"}>
                                    <h2 className={"App_sessionTitle"}>{this.props.t("finishedSessions")}</h2>
                                    <hr/>
                                </div>
                                {Object.keys(this.state.eventGroupListEnded).length > 0 ? (
                                    Object.keys(this.state.eventGroupListEnded).map((year) => {
                                        return (
                                            <div key={"started_year_" + year}>
                                                <div className={"col-md-12"} style={{padding: 0}}>
                                                    <span className={"App_year"}>{year}</span>
                                                    <hr style={{marginTop: 0}}/>
                                                </div>
                                                {this.state.eventGroupListEnded[year].map((eventGroup) => {
                                                    return (
                                                        <Collapsible
                                                            key={"event_group_" + eventGroup[0][0].event_group_id}
                                                            open={false}
                                                            trigger={
                                                                <div className={"row"}>
                                                                    <div className={"col-md-12"} style={{backgroundImage: "linear-gradient(to right, #F7F7F7 0, #eb1f247d 100%)", margin: "0 8px 5px 8px", borderRadius: 5, cursor: "pointer"}}>
                                                                        <span className={"text-center App_title"} style={{fontStyle: "italic", fontSize: 25}}>
                                                                            {eventGroup[0][0].event_group_name}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            }
                                                        >
                                                            <div className={"row row-flex"}>
                                                                {eventGroup.map((event, i) => {
                                                                    return (
                                                                        <div className={"col-xs-12 collapseMargin"} key={event[0].event_name + "_" + i}>
                                                                            <div className={"col-md-12"}>
                                                                                <h4 className={"App_eventName"}>{event[0].event_name}</h4>
                                                                            </div>
                                                                            <div className={"col-xs-12 collapseMargin"}>
                                                                                {event.map((session) => {
                                                                                    return (
                                                                                        <SessionFinishCard
                                                                                            key={session.session_id}
                                                                                            sessionID={session.session_id}
                                                                                            event={session}
                                                                                            userID={this.props.location.state.userID}
                                                                                            privileges={this.props.location.state.privileges}
                                                                                            t={this.props.t}
                                                                                            cookies={this.props.cookies}
                                                                                            sessionDetails={this.state.sessionDetails}
                                                                                            flagList={this.state.flagList}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </Collapsible>
                                                    );
                                                })}
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div>
                                        <span className={"App_bold_text"} style={{fontSize: 22}}>{this.props.t("noFinishedSessions")}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )
        );
    }
}

class SessionUpcomingCard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
        };

        this.startSession = this.startSession.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    /* HANDLERS */
    startSession(e) {
        e.preventDefault();
        const parts = e.target.value.split("_");
        const eventID = parts[0];
        const sessionID = parts[1];
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/startSession',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: sessionID,
                startDate: Moment().unix(),
            },
            success: function () {
                helper.props.startSessionCommand(eventID, sessionID);
            },
            error: function (err) {
                if (err) {
                    console.log("[SESSION CHOICE] startCommand: ", err);
                }
            }
        });
    }

    handleOpenModal() {
        this.setState({
            modalOpen: true,
        });
    }

    handleCloseModal() {
        this.setState({
            modalOpen: false,
        });
    }

    /* RENDER */
    render() {
        return (
            <>
                <div className={"col-sm-6 col-lg-4"} style={{paddingRight: 7, paddingLeft: 7}}>
                    <div className={"panel panel-default"}>
                        <div className={"panel-heading"}>
                            <span className={"App_title"} style={{textAlign: "left", fontSize: 20}}>{this.props.event.event_name}</span>
                            {(this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) ? (
                                <>
                                    <NavLink
                                        data-tip={true}
                                        data-for={"diag"}
                                        to={{
                                            pathname: "/diagnostic/" + this.props.event.event_id + "/" + this.props.event.session_id + "/" + this.props.userID,
                                        }}
                                        className={"btn btn-primary button"}
                                        style={{fontSize: 15, fontWeight: "bold", float: "right", margin: "0 3px 3px 3px",}}
                                    >
                                        <span><i className="fas fa-tools"/></span>
                                    </NavLink>
                                    <ReactTooltip id={"diag"} type={"light"}>
                                        <span className={"toolTipStyle"}>{this.props.t("diagnoseDevices")}</span>
                                    </ReactTooltip>
                                </>
                            ) : null}
                        </div>
                        <div className={"panel-body"} style={{padding: 0}}>
                            <div className={"col-xs-12 App_text"} style={{fontSize: 17, paddingRight: 7, paddingLeft: 7}}>
                                <div className={"col-xs-2"} style={{color: "#ed2126"}}>
                                    {this.props.t("description")}
                                </div>
                                <div className={"col-xs-10"}>
                                    {this.props.event.session_name}
                                </div>
                                <div className={"col-xs-2"} style={{color: "#ed2126"}}>
                                    {this.props.t("type")}
                                </div>
                                <div className={"col-xs-10"}>
                                    {this.props.event.session_type}
                                </div>
                                <div className={"col-xs-2"} style={{color: "#ed2126"}}>
                                    {this.props.t("date")}
                                </div>
                                <div className={"col-xs-10"}>
                                    {formatDate((this.props.event.session_start ? this.props.event.session_start : this.props.event.scheduled_session_start) * 1000, this.props.event.timezone)}
                                </div>
                            </div>
                        </div>
                        <div className={"panel-footer text-center"}>
                            {(this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) ? (
                                <button
                                    className={"btn btn-primary button"}
                                    style={{fontSize: 17}}
                                    onClick={this.handleOpenModal}
                                    disabled={this.props.event.can_start === "0"}
                                >
                                    {this.props.t("startSession")}
                                </button>
                            ) : (
                                <div/>
                            )}
                        </div>
                    </div>
                </div>
                <Modal open={this.state.modalOpen}
                       onClose={this.handleCloseModal}
                       center={false}
                       classNames={{modal: "small-modal"}}
                       showCloseIcon={false}
                >
                    <div className={"modal-header"}>
                        <div className={"modal-title"}>
                            <b className={"App_title"}>{this.props.t("areYouSure")}</b>
                        </div>
                    </div>
                    <div className={"modal-body"}>
                        <p className={"App_big_black_text"}>{this.props.t("startSession_p1")}</p>
                        <p className={"App_big_black_text"}>{this.props.t("startSession_p2")}</p>
                    </div>
                    <div className={"modal-footer"}>
                        <button
                            onClick={this.startSession}
                            className={"btn App_white_text button"}
                            value={this.props.event.event_id + "_" + this.props.event.session_id}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("yes")}
                        </button>
                        <button
                            onClick={this.handleCloseModal}
                            className={"btn App_white_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("no")}
                        </button>
                    </div>
                </Modal>
            </>
        );
    }
}

class SessionOnGoingCard extends Component {

    render() {
        return (
            <div className={"col-sm-6 col-lg-4"} style={{paddingRight: 7, paddingLeft: 7}}>
                <div className={"panel panel-default"}>
                    <div className={"panel-heading"}>
                        <span className={"App_title"} style={{textAlign: "left", fontSize: 20}}>{this.props.event.event_name}</span>
                    </div>
                    <div className={"panel-body"} style={{padding: 0}}>

                        <div className={"col-xs-12 App_text"} style={{fontSize: 17, paddingRight: 7, paddingLeft: 7}}>
                            <div className={"col-xs-2"} style={{color: "#ed2126"}}>
                                {this.props.t("description")}
                            </div>
                            <div className={"col-xs-10"}>
                                {this.props.event.session_name}
                            </div>

                            <div className={"col-xs-2"} style={{color: "#ed2126"}}>
                                {this.props.t("type")}
                            </div>
                            <div className={"col-xs-10"}>
                                {this.props.event.session_type}
                            </div>

                            <div className={"col-xs-2"} style={{color: "#ed2126"}}>
                                {this.props.t("date")}
                            </div>
                            <div className={"col-xs-10"}>
                                {formatDate((this.props.event.session_start ? this.props.event.session_start : this.props.event.scheduled_session_start) * 1000, this.props.event.timezone)}
                            </div>
                        </div>
                    </div>

                    <div className={"panel-footer text-center"}>
                        <NavLink
                            to={{
                                pathname: (this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) ? ("/screenChoice") : ("/dashboard"),
                                state: {
                                    isGuest: false,
                                    sessionID: this.props.event.session_id,
                                    eventID: this.props.event.event_id,
                                    userID: this.props.userID,
                                    privileges: this.props.privileges,
                                }
                            }}
                            className={"btn btn-primary button"}
                            style={{fontSize: 17}}
                        >{this.props.t("enterDash")}</NavLink>
                    </div>
                </div>
            </div>
        );
    }

}

class SessionFinishCard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            sessionCarList: [{bestLapOverall: "---"}],
        };

        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.popout = this.popout.bind(this);
        this.handlePopoutMini = this.handlePopoutMini.bind(this);
        this.handlePopoutMiniLive = this.handlePopoutMiniLive.bind(this);
        this.popoutLiveMaxes = this.popoutLiveMaxes.bind(this);
        this.popoutPitLaneSpeed = this.popoutPitLaneSpeed.bind(this);
        this.popoutSessionStatus = this.popoutSessionStatus.bind(this);
        this.statusIDtoObj = this.statusIDtoObj.bind(this);
        this.getSessionHistory = this.getSessionHistory.bind(this);
        this.getSessionDetails = this.getSessionDetails.bind(this);
        this.getMarshallPostList = this.getMarshallPostList.bind(this);
    }

    /* GET DATA */
    getSessionDetails() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSessionDetails',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.sessionID,
            },
            success: function (data) {
                helper.setState({
                    sessionDetails: data,
                }, () => {
                    $('.loading').fadeOut();
                    helper.setState({
                        show: true,
                    });
                });
            },
            error: function (err) {
                $('.loading').fadeOut();
                if (err) {
                    console.error('Error:', err);
                }
            }
        });
    }

    getSessionHistory() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getSessionHistory',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                userID: helper.props.userID,
                sessionID: helper.props.sessionID,
            },
            success: function (data) {
                if (data.length > 0) {
                    helper.setState({
                        sessionCarList: data,
                    }, () => {
                        helper.getSessionDetails();
                        helper.getMarshallPostList();
                    });
                } else {
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("noCarsForHistory") + '</span>', {
                        position: 'top-right',
                        effect: 'genie',
                        beep: false,
                        timeout: 10000,
                        offset: 150
                    });
                }
                $('.loading').fadeOut();
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                $('.loading').fadeOut();
                return false;
            }
        });
    }

    getMarshallPostList() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getMarshallPostList',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.sessionID,
            },
            success: function (data) {
                if (data && data.length > 0) {
                    helper.setState({
                        marshallPosts: data
                    });
                }
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
            }
        });
    }

    /* HANDLERS */
    statusIDtoObj(arr) {
        let temp = [];
        for (let i = 0; i < arr.length; i++) {
            temp.push(null);
            for (let j = 0; j < this.props.flagList.length; j++) {
                if (this.props.flagList[j].id === arr[i]) {
                    temp[i] = this.props.flagList[j];
                    break;
                }
            }
        }
        return temp;
    }

    handleShowModal(e) {
        e.preventDefault();
        $('.loading').fadeIn();
        this.getSessionHistory();
    }

    handleCloseModal() {
        this.setState({
            show: false
        });
    }

    popout(e) {
        e.preventDefault();
        const parts = e.target.value.split("_");
        window.open(
            "expandLapTimes/" + parts[0] + "/" + parts[1] + "/" + parts[2],
            'lapTimes',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=1000,height=500,left=100,top=200"
        );
    }

    handlePopoutMiniLive(e) {
        e.preventDefault();
        const parts = e.target.value.split("_");
        window.open(
            "/miniChallengeLive/" + parts[0] + "/" + parts[1] + "/" + this.props.userID,
            'miniChallengeLive',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=900"
        );
    }

    handlePopoutMini(e) {
        e.preventDefault();
        const parts = e.target.value.split("_");
        window.open(
            "/miniChallengeZones/" + parts[0] + "/" + parts[1] + "/" + parts[2] + "/" + this.props.userID,
            'miniChallengeZones',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=900"
        );
    }

    popoutLiveMaxes(e) {
        e.preventDefault();
        window.open(
            "/liveMaxes/" + this.props.event.event_id + "/" + this.props.sessionID + "/" + this.props.userID,
            'liveMaxes',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=900"
        );
    }

    popoutPitLaneSpeed(e) {
        e.preventDefault();
        window.open(
            "/livePitSpeed/" + this.props.event.event_id + "/" + this.props.sessionID + "/" + this.props.userID,
            'livePitSpeed',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=900"
        );
    }

    popoutSessionStatus(e) {
        e.preventDefault();
        window.open(
            "/sessionStatusHistory/" + this.props.event.event_id + "/" + this.props.sessionID + "/" + this.props.userID,
            'sessionStatusHistory',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=400,top=100,width=1000,height=700"
        );
    }

    /* RENDER */
    render() {
        return (
            <div className={"col-sm-6 col-lg-3"} style={{paddingRight: 7, paddingLeft: 7}}>
                <div className={"panel panel-default"}>
                    <div className={"panel-heading"}>
                        <span className={"App_title"} style={{textAlign: "left", fontSize: 20}}> {this.props.event.session_name}</span>
                    </div>
                    <div className={"panel-body"} style={{padding: 0}}>
                        <div className={"col-xs-12 App_text"} style={{fontSize: 17, paddingRight: 7, paddingLeft: 7}}>
                            <div className={"col-xs-2"} style={{color: "#ed2126"}}>
                                {this.props.t("type")}
                            </div>
                            <div className={"col-xs-10"}>
                                {this.props.event.session_type}
                            </div>
                            <div className={"col-xs-2"} style={{color: "#ed2126"}}>
                                {this.props.t("date")}
                            </div>
                            <div className={"col-xs-10"}>
                                {formatDate((this.props.event.session_start ? this.props.event.session_start : this.props.event.scheduled_session_start) * 1000, this.props.event.timezone)}
                            </div>
                        </div>
                    </div>
                    <div className={"panel-footer text-center"}>
                        <button
                            className={"btn btn-primary button"}
                            value={this.props.event.session_id}
                            onClick={this.handleShowModal}
                        >{this.props.t("checkHistory")}
                        </button>
                    </div>
                </div>
                <Modal open={this.state.show}
                       onClose={this.handleCloseModal}
                       center={true}
                       classNames={{modal: "medium-modal"}}
                       showCloseIcon={false}
                >
                    <div className={"modal-header"}>
                        <div className={"modal-title"}><b className={"App_title"}>{this.state.sessionCarList[0].session_name}</b></div>
                        <div className={"modal-title"}><b className={"App_smallHeader"} style={{color: "#000000"}}>{this.props.t("chooseCarHistory")}</b></div>
                    </div>
                    <div className={"modal-body"}>
                        <div className={"table-scroll-parent"} style={{height: "70vh"}}>
                            <div className={"table-scroll-child showScrollBar"}>
                                <span className={"App_bold_text"} style={{fontSize: 25}}>{this.props.t("bestLapOfSession")}: </span>
                                <span className={"App_bestLapStyle"} style={{fontSize: 25}}>{this.state.sessionCarList[0] ? formatTime(this.state.sessionCarList[0]["best_lap_overall"]) : "---"}</span>
                                <hr style={{marginBottom: 0}}/>
                                {this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin) ? (
                                    <>
                                        <span className={"App_bold_text"} style={{fontSize: 20}}>{this.props.t("historic")}</span>
                                        <div className={"row"}>
                                            <div className={"col-md-4"}>
                                                <button
                                                    type={"button"}
                                                    className={"btn btn-primary btn-block button App_bold_text"}
                                                    style={{fontSize: 17}}
                                                    onClick={this.popoutLiveMaxes}
                                                >
                                                    <span>{this.props.t("checkMaxValues")}</span>
                                                    <span><i className={"fas fa-tachometer-alt"}/></span>
                                                </button>
                                            </div>
                                            <div className={"col-md-4"}>
                                                <button
                                                    type={"button"}
                                                    className={"btn btn-primary btn-block button App_bold_text"}
                                                    style={{fontSize: 17}}
                                                    onClick={this.popoutPitLaneSpeed}
                                                >
                                                    <span>{this.props.t("checkPitHistory")}</span>
                                                    <span><i className={"fas fa-stop-circle"}/></span>
                                                </button>
                                            </div>
                                            <div className={"col-md-4"}>
                                                <button
                                                    type={"button"}
                                                    value={this.props.event.session_id}
                                                    className={"btn btn-primary btn-block button App_bold_text"}
                                                    style={{fontSize: 17}}
                                                    onClick={this.popoutSessionStatus}
                                                >
                                                    <span>{this.props.t("checkFlagHistory")}</span>
                                                    <span><i className={"fas fa-flag"}/></span>
                                                </button>
                                            </div>
                                            {this.props.event.session_type_id === MiniPitStopSessionTypeID ? (
                                                <div className={"col-md-4"}>
                                                    <button
                                                        className={"btn btn-primary button"}
                                                        style={{fontSize: 17, float: "right"}}
                                                        value={this.props.event.event_id + "_" + this.props.event.session_id}
                                                        onClick={this.handlePopoutMiniLive}
                                                    >{this.props.t("chooseLastSnapshot")}
                                                    </button>
                                                </div>
                                            ) : null}
                                        </div>
                                    </>
                                ) : null}

                                <table className={"table"}>
                                    <thead>
                                    <tr>
                                        <th className={"App_title"} style={{textAlign: "left", fontSize: 22}}>{this.props.t("vehicle")}</th>
                                        <th className={"App_title"} style={{textAlign: "left", fontSize: 22}}>{this.props.t("team")}</th>
                                        <th className={"App_title"}/>
                                        <th className={"App_title"}/>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.sessionCarList.map((car, i) => {

                                        let statusColor = "";
                                        let statusText = "";
                                        let statusOpacity = "";

                                        switch (car.rsi) {
                                            case (2): {
                                                statusColor = "#be2000";
                                                statusText = "DNF - ";
                                                statusOpacity = "40";
                                                break;
                                            }
                                            case (3): {
                                                statusColor = "#e09d00";
                                                statusText = "DNS - ";
                                                statusOpacity = "40";
                                                break;
                                            }
                                            default: {
                                                statusColor = "#FFFFFF";
                                                statusText = "";
                                                statusOpacity = "";
                                                break;
                                            }
                                        }

                                        return (
                                            <tr key={i} className={"App_bold_text"} style={{fontSize: 19, backgroundColor: (statusColor + statusOpacity)}}>
                                                <td>{statusText + "#" + car.livery_number}</td>
                                                <td style={{color: (car.best_lap_time === car.best_lap_overall ? "#ca00a5" : "#000000"), textAlign: "left"}}>{car.title}</td>
                                                <td>
                                                    {this.props.event.session_type_id === MiniPitStopSessionTypeID ? (
                                                        <button
                                                            className={"btn btn-primary button"}
                                                            style={{fontSize: 17, marginRight: 3}}
                                                            value={car.event_id + "_" + car.session_id + "_" + car.id}
                                                            onClick={this.handlePopoutMini}
                                                        >{this.props.t("checkZoneHistory")}
                                                        </button>
                                                    ) : (
                                                        <div/>
                                                    )}
                                                    <button
                                                        className={"btn btn-primary button"}
                                                        style={{fontSize: 17}}
                                                        value={car.event_id + "_" + car.session_id + "_" + car.id}
                                                        onClick={this.popout}
                                                        disabled={car.isOwnTeam === 0}
                                                    >{this.props.t("viewLaps")}
                                                    </button>
                                                </td>
                                                <td>
                                                    <LoggingBox
                                                        privileges={this.props.privileges}
                                                        carID={car.id}
                                                        teamName={"#" + car.livery_number + " " + car.title}
                                                        sessionID={car.session_id}
                                                        userID={this.props.userID}
                                                        isOwnTeam={car.isOwnTeam}
                                                        disabled={car.isOwnTeam === 0}
                                                        convertFlags={this.statusIDtoObj}
                                                        isSessionChoice={true}
                                                        sessionDetails={this.state.sessionDetails}
                                                        marshallPosts={this.state.marshallPosts}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className={"modal-footer"}>
                        <button
                            onClick={this.handleCloseModal}
                            className={"btn App_white_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("close")}
                        </button>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default withTranslation("translations")(withCookies(SessionChoice));
